module.exports = __webpack_public_path__ + "static/media/manipulacjaAWywieranieWplywu.1e96455e.png";